import { defineStore } from 'pinia'
import type { RouteRecordRaw } from 'vue-router'
import cloneDeep from 'lodash/cloneDeep'
import { getMenu, getUserMenuPermissions, type Menu } from '@/api/permission'
import type { User } from '@/api/modules/systemManage/user'
import type { Role } from '@/api/modules/systemManage/role'
import { useAppStore } from './app'
import Layout from '@/layout/index.vue'

type PermissionState = {
	authButtons: Recordable<Recordable<any>>
	loadNavs: boolean
	hamMenus: Menu[] // 汉堡菜单list
	hamRouters: RouteRecordRaw[] // 汉堡菜单 动态路由
}
export const usePermissionStore = defineStore({
	id: 'permission',
	state: (): PermissionState => ({
		authButtons: {}, // 用户按钮权限列表
		loadNavs: false,
		hamMenus: [], // 汉堡菜单list
		hamRouters: [], // 汉堡菜单 动态路由
	}),
	actions: {
		// 用户信息改变后处理
		async userInfoChangeHandle(changedUser: User & { roleIdList: Role['roleId'][] }) {
			const appStore = useAppStore()
			const loginUser = appStore.userInfo
			// 不是当前用户信息改变 return
			if (changedUser.userId !== loginUser.userId) return true
			// 当前用户信息改变
			// roleList改变 刷新页面(菜单、按钮权限、个人信息 更新)
			if (loginUser.roleList.length !== changedUser.roleIdList.length || loginUser.roleList.some((role: Role) => !changedUser.roleIdList.includes(role.roleId)))
				return location.reload()

			// 重新获取登录用户信息
			return appStore.getLoginUserDetail()
		},
		//角色改变后处理
		roleInfoChangeHandle(changedRole: Role) {
			const loginUser = useAppStore().userInfo
			//如果 改变的role在当前用户的 roleList里面
			if (!loginUser.roleList.find((role: Role) => role.roleId === changedRole.roleId)) {
				return true
			}
			// (菜单、按钮权限、个人信息 更新)
			if (loginUser.roleList.find((role: Role) => role.roleId === changedRole.roleId)) return location.reload()
		},
		async getMenu() {
			const menus = await getMenu()
			// const menus = ms as any
			formatData(menus)
			this.hamMenus = menus
			this.hamRouters = markRaw(formatHamRouter(menus))
		},
		async getUserMenuPermissions() {
			const authWithButtons = await getUserMenuPermissions()
			this.authButtons = authWithButtons
		},
	},
})

// 格式化树数据结构
export function formatData(menus: Menu[]) {
	const menuList = [...menus]
	for (const item of menuList) {
		item.meta.menuId = String(item.menuId)
		//todo
		// if (item.menuId === 1002000) {
		// 	item.children.push({
		// 		menuId: 10033001,
		// 		parentMenuId: 1002000,
		// 		component: '/modules/dataStat/task/PageLearnerFeedBackStat',
		// 		name: 'PageLearnerFeedBackStat',
		// 		path: 'pageLearnerFeedBackStat',
		// 		meta: {
		// 			title: '反馈列表',
		// 			icon: '',
		// 		},
		// 		sortNo: 26,
		// 		children: [],
		// 	})
		// }
		if (item.menuId === 400000) {
			item.children.push({
				menuId: 405000,
				parentMenuId: 400000,
				component: '/modules/learnerManage/appConfig/AppConfig',
				name: 'AppConfig',
				path: 'appConfig',
				meta: {
					title: '报名管理',
					icon: '',
				},
				sortNo: 11,
				children: [],
			})
		}
		if (item.menuId === 500000) {
			// 动态添加APP版本管理菜单
			item.children.push({
				menuId: 504000,
				parentMenuId: 500000,
				component: '/modules/systemManage/appVersion/AppVersionManage',
				name: 'AppVersionManage',
				path: 'appVersionManage',
				meta: {
					title: 'APP版本管理',
					icon: '',
				},
				sortNo: 60000,
				children: [],
			})
		}
		if (item?.children?.length) {
			formatData(item.children)
		}
	}
}

const modules = import.meta.glob('@/views/**/**.vue')

// 初始化动态路由
export const formatHamRouter = (menus: Menu[], sumArr: RouteRecordRaw[] = []): RouteRecordRaw[] => {
	const newMenus = cloneDeep(menus)
	// 遍历后台传来的路由字符串，转换为组件对象
	return newMenus.reduce((sumArr, menu) => {
		const { path, component, meta, name, children } = menu
		const router = { path, component, meta, name, children }
		if (children.length) {
			return formatHamRouter(children, sumArr)
		}
		if (!path) {
			return sumArr
		}
		router.component = !component || component === 'Layout' ? Layout : loadView(component as string)
		sumArr.push(router as RouteRecordRaw)
		return sumArr
	}, sumArr)
}

export const loadView = (view: string) => {
	// todo
	if (view === '/modules/taskManage/task/SurveyManage') {
		view = view.replace('/task/', '/survey/')
	}
	return modules[`/src/views${view}.vue`] || modules[`/src/views${view}/index.vue`]
}
